var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreen = function SvgScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 1.28,
    d: "M23.36 16H9.28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "square",
    strokeWidth: 0.64,
    d: "M10.88 11.2v9.6M13.44 11.2v9.6M16 11.2v9.6M18.56 11.2v9.6M21.12 11.2v9.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M8.75 11.63h14.5v8.74H8.75z"
  })));
};
export { SvgScreen as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cline x1='23.36' y1='16.0001' x2='9.28' y2='16.0001' stroke='%234A6067' stroke-width='1.28' stroke-linecap='square'/%3e %3cline x1='10.8801' y1='11.1999' x2='10.8801' y2='20.7999' stroke='%234A6067' stroke-width='0.64' stroke-linecap='square'/%3e %3cline x1='13.44' y1='11.1999' x2='13.44' y2='20.7999' stroke='%234A6067' stroke-width='0.64' stroke-linecap='square'/%3e %3cline x1='16.0001' y1='11.1999' x2='16.0001' y2='20.7999' stroke='%234A6067' stroke-width='0.64' stroke-linecap='square'/%3e %3cline x1='18.56' y1='11.1999' x2='18.56' y2='20.7999' stroke='%234A6067' stroke-width='0.64' stroke-linecap='square'/%3e %3cline x1='21.12' y1='11.1999' x2='21.12' y2='20.7999' stroke='%234A6067' stroke-width='0.64' stroke-linecap='square'/%3e %3crect x='8.75' y='11.6299' width='14.5' height='8.74' stroke='%234A6067' stroke-width='1.5'/%3e %3c/svg%3e";